import api from '../../utils/api';

export interface InstantConsultationSectionDto {
  id: string;
  title: string;
  slug: string | null;
  description: string | null;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

const base = '/master-admin/vendor-reference-data/instant-consultation-sections';

export async function fetchInstantConsultationSections(params?: {
  isActive?: boolean;
  search?: string;
}): Promise<{ success: boolean; data: InstantConsultationSectionDto[] }> {
  const response = await api.get(base, { params });
  return response.data;
}

export async function createInstantConsultationSection(body: {
  title: string;
  slug?: string;
  description?: string;
  sortOrder?: number;
  isActive?: boolean;
}): Promise<{ success: boolean; data: InstantConsultationSectionDto }> {
  const response = await api.post(base, body);
  return response.data;
}

export async function updateInstantConsultationSection(
  id: string,
  body: Partial<{
    title: string;
    slug: string;
    description: string;
    sortOrder: number;
    isActive: boolean;
  }>
): Promise<{ success: boolean; data: InstantConsultationSectionDto }> {
  const response = await api.patch(`${base}/${id}`, body);
  return response.data;
}

export async function deleteInstantConsultationSection(
  id: string
): Promise<{ success: boolean }> {
  const response = await api.delete(`${base}/${id}`);
  return response.data;
}
